import angular from "angular"

import AuthService, {
  UserTokenInfo,
} from "../../../app/services/auth/auth.service"
import Organization from "../../../app/model/domain/organization"
import OrganizationService from "../../../app/services/organization/organization.service"
import { Locations } from "../../../app/services/mixpanel/mixpanel.service"
import IncentiveAssignmentLimitV1Controller from "../../../app/components/incentive-assignment-limit-v1-dialog/incentive-assignment-limit-v1-dialog.controller"
import AdminInvitesTeachersDialogController from "../../../app/components/admin-invites-teachers-dialog/admin-invites-teachers-dialog.controller"
import { statsTimePeriod } from "../statsTimePeriod"
import { TeacherUsageStats } from "../../../app/model/domain/teacher-usage-stats"
import AnalyticsService from "../../../app/services/analytics/analytics.service"
import { SortingState } from "../DataTable"

export class TeachersMetricsPageController {
  private user: UserTokenInfo
  private incentiveAssignmentLimitV1 = IncentiveAssignmentLimitV1Controller.show
  private adminInvitesTeachersDialog = AdminInvitesTeachersDialogController.show
  public organizationId: string

  constructor(
    private $stateParams: angular.ui.IStateParamsService,
    private $mdDialog: angular.material.IDialogService,
    private $mdSidenav: angular.material.ISidenavService,
    private AuthService: AuthService,
    private OrganizationService: OrganizationService,
    private AnalyticsService: AnalyticsService,
  ) {
    "ngInject"

    this.user = this.AuthService.authData
    this.organizationId = this.$stateParams.organizationId

    this.AnalyticsService.TeachersMetricsPageOpened(
      this.user,
      this.organizationId,
    )
  }

  getTeachersUsageStats(organizationId: string): Promise<TeacherUsageStats[]> {
    return this.OrganizationService.getTeachersUsageStats(organizationId)
  }

  getOrganization(organizationId: string): Promise<Organization> {
    return this.OrganizationService.get(organizationId)
  }

  isUserContractAdmin(contractId?: string): boolean {
    if (!contractId) return false
    return this.user.isContractAdmin(contractId)
  }

  inviteUsers(organization: Organization | undefined): void {
    this.incentiveAssignmentLimitV1(
      Locations.METRICS,
      this.$mdDialog,
      this.user,
      [organization],
    )
  }

  nudgeTeachers(organization: Organization | undefined): void {
    this.adminInvitesTeachersDialog(
      this.$mdDialog,
      organization && organization.id,
      Locations.METRICS,
    )
  }

  get statsTimePeriod(): string {
    return statsTimePeriod()
  }

  get errorMessage(): string {
    return "Sorry, there was a problem loading the metrics for this organization"
  }

  trackMetricsTableSort(sorting: SortingState): void {
    this.AnalyticsService.allTeachersTable_sorted(sorting)
  }

  toggleSidenav(): void {
    this.$mdSidenav("nav").toggle()
  }
}
